var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-50 flex w-full flex-1 flex-col justify-end rounded-md"},[_c('div',{staticClass:"w-full px-4 pt-4"},[_c('team-availability',{attrs:{"available-agents":_vm.availableAgents,"has-conversation":!!_vm.conversationSize,"unread-count":_vm.unreadMessageCount},on:{"start-conversation":_vm.startConversation}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }